import { render, staticRenderFns } from "./CreateIndex.vue?vue&type=template&id=4d7b2b28&scoped=true"
import script from "./CreateIndex.vue?vue&type=script&lang=ts"
export * from "./CreateIndex.vue?vue&type=script&lang=ts"
import style0 from "./CreateIndex.vue?vue&type=style&index=0&id=4d7b2b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7b2b28",
  null
  
)

export default component.exports